"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForMinedTransaction = exports.convertResultToNumber = exports.convertResultToBigNumber = exports.convertResultToAddress = exports.convertResultToString = exports.validateAndParseAddress = exports.multicallMultipleContractSingleData = exports.multicallMultipleContractMultipleData = exports.MULTI_CALL = void 0;
const connect_1 = require("@celo/connect");
const address_1 = require("@ethersproject/address");
const abi_json_1 = __importDefault(require("./abi.json"));
const tiny_warning_1 = __importDefault(require("tiny-warning"));
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const utils_1 = require("../utils");
exports.MULTI_CALL = "0x75f59534dd892c1f8a7b172d639fa854d529ada3"; // TODO: Extend to multichain
async function multicallMultipleContractMultipleData(web3, payload) {
    const multicallContract = new web3.eth.Contract(abi_json_1.default, exports.MULTI_CALL);
    const calls = payload.map(({ targetInterface, target, method, data }) => {
        const fragment = targetInterface.getFunction(method);
        const call = [
            target,
            targetInterface.encodeFunctionData(fragment, data !== null && data !== void 0 ? data : []),
        ];
        return call;
    });
    const chunkedCalls = (0, utils_1.chunkArray)(calls, Math.ceil(calls.length / 2));
    const results = await Promise.all(chunkedCalls.map((call) => multicallContract.methods.aggregate(call).call()));
    const returnData = results.flatMap((el) => el.returnData);
    return returnData.map((res, i) => {
        const { targetInterface, method, transformResult } = payload[i];
        const fragment = targetInterface.getFunction(method);
        const decodedResult = targetInterface.decodeFunctionResult(fragment, res);
        const result = transformResult
            ? transformResult(decodedResult)
            : decodedResult;
        return result;
    });
}
exports.multicallMultipleContractMultipleData = multicallMultipleContractMultipleData;
async function multicallMultipleContractSingleData(targetInterface, targets, method, data) {
    const multicallContract = new connect_1.Contract(abi_json_1.default, exports.MULTI_CALL);
    const fragment = targetInterface.getFunction(method);
    const calls = targets.map((target) => [
        target,
        targetInterface.encodeFunctionData(fragment, data),
    ]);
    const { returnData } = await multicallContract.methods.aggregate(calls).call();
    return returnData.map((el) => targetInterface.decodeFunctionResult(fragment, el));
}
exports.multicallMultipleContractSingleData = multicallMultipleContractSingleData;
/**
 *
 * @param address string to check if an address is valid and checksummed
 * @returns checksummed address, or undefined if address is invalid
 */
function validateAndParseAddress(address) {
    let checksummedAddress = "";
    try {
        checksummedAddress = (0, address_1.getAddress)(address);
        (0, tiny_warning_1.default)(address === checksummedAddress, `${address} is not checksummed.`);
        return checksummedAddress;
    }
    catch (error) {
        (0, tiny_invariant_1.default)(false, `${address} is not a valid address.`);
    }
    return checksummedAddress;
}
exports.validateAndParseAddress = validateAndParseAddress;
/**
 *
 * @param result Result object from multicall
 * @param i index of value within Result, default 0
 * @returns string representation of ith value in Result
 */
const convertResultToString = (result, i = 0) => result === null || result === void 0 ? void 0 : result[i].toString();
exports.convertResultToString = convertResultToString;
/**
 *
 * @param result Result object from multicall
 * @param i index of value within Result, default 0
 * @returns address of ith value in Result
 */
const convertResultToAddress = (result, i = 0) => validateAndParseAddress((0, exports.convertResultToString)(result, i));
exports.convertResultToAddress = convertResultToAddress;
/**
 *
 * @param result Result object from multicall
 * @param i index of value within Result, default 0
 * @returns BigNumber of ith value in Result
 */
const convertResultToBigNumber = (result, i = 0) => new bignumber_js_1.default((0, exports.convertResultToString)(result, i));
exports.convertResultToBigNumber = convertResultToBigNumber;
/**
 *
 * @param result Result object from multicall
 * @param i index of value within Result, default 0
 * @returns Number of ith value in Result
 */
const convertResultToNumber = (result, i = 0) => parseInt((0, exports.convertResultToString)(result, i));
exports.convertResultToNumber = convertResultToNumber;
/**
 *
 * @param txnHash Hash of transaction waiting to be mined
 * @param web3 web3 object
 * @returns status of the transaction (true = success, false = revert)
 */
async function waitForMinedTransaction(txnHash, web3) {
    let receipt = await web3.eth.getTransactionReceipt(txnHash);
    while (!receipt) {
        await new Promise((r) => setTimeout(r, 5000));
        receipt = await web3.eth.getTransactionReceipt(txnHash);
    }
    return receipt.status;
}
exports.waitForMinedTransaction = waitForMinedTransaction;
//# sourceMappingURL=index.js.map